module.exports = "/img/_/_/_/assets/images/creeper/battle/common//40.jpg?66d7afe4fcfa5ce6938125a91555d9ea";